import { render, staticRenderFns } from "./ChangeMainContactLeads.vue?vue&type=template&id=5e239734&"
import script from "./ChangeMainContactLeads.vue?vue&type=script&lang=js&"
export * from "./ChangeMainContactLeads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports